import * as React from 'react';
import { useState, useCallback } from 'react';
import { useFragment } from 'react-relay';
import { cutOffTableFragment } from './CutOffTable.relay';
import { CutOffTableHeader } from './lib/cutOffTableHeader';
import { CoTranche } from './lib/coTranche';
import type { CutOffTablePropsType } from './types';

const CutOffTable: React.FC<CutOffTablePropsType> = ( props ) => {
    const table = useFragment( cutOffTableFragment, props.table );

    const [ selectedItem, setSelectedItem ] = useState<string | null>( null );
    const [ header, setHeader ] = useState<any>( null );

    const convertHeader = useCallback( ( headerData ) => {
        const output = {};
        headerData.forEach( ( item ) => {
            output[item.col.toLowerCase()] = item.label;
        } );
        return output;
    }, [] );

    const filterTrancheSalesAdmission = useCallback( ( tranche: any ): boolean => {
        if ( !tranche.node.salesAdmission.length ) {
            return false;
        }
        return tranche.node.salesAdmission.indexOf( props.salesAdmission.toUpperCase() ) > -1;
    }, [ props.salesAdmission ] );

    const tranches = table.entries.edges.filter( filterTrancheSalesAdmission );

    return (
        <div className='mt-5 w-full'>
            <div className='clear-both leading-[1.3] text-[#686868]'>
                {props.introduction}
            </div>
            <table className='Table w-full max-w-[1000px] table-auto border-0 border-separate border-spacing-y-[5px] [&&_th:not(:first-child):not(.TableHeaderCell-Isin)]:pl-5 [&&_.TableHeaderCell-FundName]:pr-2.5 [&&_.TableHeaderCell-Currency]:font-[Arial] [&&_.TableHeaderCell-Currency]:text-sm [&&_.TableHeaderCell-Currency]:text-black [&&_.TableHeaderCell-Frequency]:font-[Arial] [&&_.TableHeaderCell-Frequency]:text-sm [&&_.TableHeaderCell-Frequency]:text-black [&&_.TableHeaderCell-FrequencyComment]:font-[Arial] [&&_.TableHeaderCell-FrequencyComment]:text-sm [&&_.TableHeaderCell-FrequencyComment]:text-black [&&_.TableHeaderCell-CutOffTime]:font-[Arial] [&&_.TableHeaderCell-CutOffTime]:text-sm [&&_.TableHeaderCell-CutOffTime]:text-black [&&_.TableHeaderCell-ValueDate]:font-[Arial] [&&_.TableHeaderCell-ValueDate]:text-sm [&&_.TableHeaderCell-ValueDate]:text-black max-[1100px]:block max-[1100px]:[&&_thead]:block max-[1100px]:[&&_tbody]:block'>
                <colgroup>
                    <col span={ 1 } />
                    <col className='total' />
                </colgroup>

                <CutOffTableHeader
                    header={ table }
                    getHeaderCallback={ ( headerData ) => {
                        if ( !header ) {
                            setTimeout( () => setHeader( convertHeader( headerData ) ), 0 );
                        }
                    } }
                />
                <tbody>
                    {tranches.map( ( tranche ) => (
                        <CoTranche
                            key={ tranche.node.id }
                            tranche={ tranche.node as any }
                            header={ header }
                            onClick={ () => setSelectedItem(
                                selectedItem === tranche.node.id ? null : tranche.node.id
                            ) }
                            className={ selectedItem === tranche.node.id ? 'CutOffTable-selectedTranche' : null }
                        />
                    ) )}
                </tbody>
            </table>
        </div>
    );
};

export { CutOffTable };
